import React from 'react';
import config from '../../config/picea.json';

class Picea {
	constructor (props) {
		this.units = config.units;
		this.flows = config.flows;
	}
}

export default Picea;


// WEBPACK FOOTER //
// ./src/components/Picea/index.jsx